import { ProgressBarInfo } from '@apply/components';
import { BorrowerType } from '../../../../../../../../../common/components/v2/BorrowerSelector/constants/borrowerSelection';
import { BorrowerForm } from '../constants/borrowerForm';

/**
 * Completion for the Borrower section: the borrower entity, or the B-Client agreement, is required unless it's locked
 * (like EditStdLoanModal, where a disabled selector wasn't validated). Broker is optional.
 */
export const getBorrowerProgress = (form: BorrowerForm, isLocked: boolean): ProgressBarInfo => {
    if (isLocked) {
        return { numberComplete: 0, total: 0 };
    }
    const isComplete =
        form.borrowerType === BorrowerType.BClient ? !!form.brokerAgreementId : !!form.borrowerEntityId;
    return { numberComplete: isComplete ? 1 : 0, total: 1 };
};
